import React from 'react';
import { trackEvent } from 'utils/google-tag-manager';
import PhoneIcon from 'components/icon/phone-icon';
import styles from '../style.module.scss';
import { GTM_CLICK_CALL_CTA } from 'constants/events';

export type PhoneCTAProps = {
  readonly phoneNumber: string;
  readonly onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

const defaultOnClick: React.MouseEventHandler<HTMLAnchorElement> = () => {
  trackEvent(GTM_CLICK_CALL_CTA); // FIXME: event tracking should not be done in components, but in the container (e.g. the page, controller, etc.)
};

export default function PhoneCTA({ phoneNumber, onClick }: PhoneCTAProps) {
  return (
    <div className={styles['phone-number-container']}>
      <a href={`tel:${phoneNumber}`} className={styles['phone-number']} onClick={onClick || defaultOnClick}>
        <PhoneIcon /> Call us {phoneNumber}
      </a>
    </div>
  );
}
